import type { ConstructedDeliverable } from "@/types/types";
import { apolloClient } from "@/apollo/index";

import setReportingLabelMutation from "@/apollo/mutations/v2/SetReportingLabel.gql";
import removeReportingLabelMutation from "@/apollo/mutations/v2/RemoveReportingLabel.gql";

import getComputedDeliverableIdentifiers from "./getComputedDeliverableIdentifiers";

export async function setComputedDeliverablesReportingLabel(
    campaignId: string,
    deliverable: ConstructedDeliverable,
    reportingLabel: string
) {
    const [computedDeliverableIdentifier] = getComputedDeliverableIdentifiers([deliverable]);

    const { data, errors = [] } = await apolloClient.mutate<{
        setComputedDeliverableCustomReportingLabel: {
            reportingLabel: string;
        };
    }>({
        mutation: setReportingLabelMutation,
        variables: {
            campaignId,
            computedDeliverableIdentifier,
            reportingLabel
        }
    });

    if (errors.length) {
        throw new Error(errors[0].message);
    }

    return data!.setComputedDeliverableCustomReportingLabel.reportingLabel;
}

export async function removeComputedDeliverablesReportingLabel(
    campaignId: string,
    deliverable: ConstructedDeliverable
) {
    const [computedDeliverableIdentifier] = getComputedDeliverableIdentifiers([deliverable]);

    const { data, errors = [] } = await apolloClient.mutate<{
        removeComputedDeliverableCustomReportingLabel: {
            reportingLabel: string;
        };
    }>({
        mutation: removeReportingLabelMutation,
        variables: {
            campaignId,
            computedDeliverableIdentifier
        }
    });

    if (errors.length) {
        throw new Error(errors[0].message);
    }

    return data!.removeComputedDeliverableCustomReportingLabel.reportingLabel;
}
